import { init } from '@ln/user.client.libs';
import { Config } from './config'
 
function UserClientLibs(){
    return init({ keyDatadog: Config.DDClientToken, googleIdClient: Config.googleClientId });
}

const UCL = UserClientLibs();

module.exports = {
    UCL
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/UserClientLibs.js